import { Component, EventEmitter, Input, OnInit, Output, ViewChild, computed, input, signal } from '@angular/core';
import { NgxFloatUiContentComponent } from 'ngx-float-ui';
import { DropdownConfig, Option, OptionValue } from 'src/index';
import { compareSelectedValue } from 'src/index/services.index';

@Component({
  selector: 'meta-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrl: './dropdown.component.css'
})
export class DropdownComponent implements OnInit {
  private defaultEmptyLabel = 'Seleziona';
  $config = input<Partial<DropdownConfig>>({
    emptyLabel: this.defaultEmptyLabel,
  }, { alias: 'config' });

  $dropdownPosition = computed(() => {
    if (this.$config().style?.openUp) {
      return this.$config().style?.openUp ? 'top' : 'bottom';
    }
    if (this.$config().style?.openLeft) {
      return this.$config().style?.openLeft ? 'bottom-start' : 'bottom';
    }
    return 'bottom';
  })
  options = input<Option[] | string[] | undefined | null>([]);

  @Input() set selectedValue(val: OptionValue | OptionValue[] | undefined) {
    this.$internalSelectedValue.set(val);
  }
  $disabled = input<boolean>(false, { alias: 'disabled' });
  private $internalSelectedValue = signal<OptionValue | OptionValue[]>(undefined);

  @Output() optionSelected = new EventEmitter<OptionValue>();
  @Output() optionsSelected = new EventEmitter<OptionValue[]>();

  @ViewChild('dropdownContent') dropdownContent: NgxFloatUiContentComponent | undefined;

  private $normalizedOptions = computed(() => {
    let options: Option[] = (this.options() || []).map(opt => {
      if (typeof opt === 'string') {
        return {
          value: opt,
          label: opt,
        };
      }
      return opt;
    });
    if (!this.$config().hideDefaultValue) {
      return [{ value: undefined, label: this.$config().emptyLabel || this.defaultEmptyLabel }, ...options];
    } else {
      return [...options];
    }
  });

  $options = computed(() => {
    return this.$normalizedOptions().map(opt => {
      let selected = false;
      const internalSelectedValue = this.$internalSelectedValue();
      if (Array.isArray(internalSelectedValue)) {
        selected = !!internalSelectedValue.find(sv => compareSelectedValue(opt.value, sv));
      } else {
        selected = compareSelectedValue(opt.value, internalSelectedValue);
      }
      return {
        ...opt,
        selected,
      };
    });
  });

  $defaultOption = computed(() => this.$config().hideDefaultValue ? { value: undefined, label: this.$config().emptyLabel || this.defaultEmptyLabel } : this.$options()[0]);
  $currentSelection = computed(() => {
    const internalSelectedValue = this.$internalSelectedValue();
    if (Array.isArray(internalSelectedValue)) {
      return this.$options().filter(opt => internalSelectedValue.find(sv => compareSelectedValue(opt.value, sv)));
    } else {
      return this.$options().find(opt => compareSelectedValue(opt.value, internalSelectedValue)) || this.$defaultOption();
    }
  });

  $selectedOption = computed<Option | undefined>(() => {
    const currentSelection = this.$currentSelection();
    if (Array.isArray(currentSelection)) {
      return {
        selected: true,
        value: currentSelection.map(opt => opt.value).join('_'),
        label: `${this.$config().emptyLabel} ${currentSelection.length ? `(${currentSelection.length})` : ''}`,
      };
    } else {
      return currentSelection;
    }
  });

  public dropdown: OptionValue;

 
  
  ngOnInit(): void {
    if (this.$config().emitValueOnInit) {
      const currentSelection = this.$selectedOption();
      if (currentSelection && this.$internalSelectedValue()) {
        if (JSON.stringify(currentSelection.value) !== this.$internalSelectedValue()) {
          this.optionSelected.emit(currentSelection.value);
        }
      }
    }
  }

  compareSelectedValue = compareSelectedValue;

  selectOption(option: Option) {
    let selectedValue = this.$internalSelectedValue();
    if (this.$config().multipleSelection && option.value) {
      const newSelectedValue = (selectedValue || []) as OptionValue[];
      // toggle selection
      const selectedIndex = newSelectedValue.findIndex(sv => compareSelectedValue(sv, option.value));
      if (selectedIndex >= 0) {
        newSelectedValue.splice(selectedIndex, 1);
      } else {
        newSelectedValue.push(option.value);
      }
      // Multiple selection will emit on hide
      this.$internalSelectedValue.set([...newSelectedValue]);
      this.optionsSelected.emit(this.$internalSelectedValue() as OptionValue[]);
    } else {
      this.optionSelected.emit(option.value);
      this.$internalSelectedValue.set(option.value);
      this.dropdownContent?.hide();
    }
  }

  hide() {
    this.dropdownContent?.hide();
  }
}
